module.exports = __webpack_public_path__ + "static/media/NeritoOurApp3.85c51837.svg";